import {
  PASSWORD_GET_REQUEST,
  PASSWORD_GET_SUCCESS,
  PASSWORD_GET_FAILURE,
} from './ResetPasswordActionType';

const initialState = {
  loading: true,
  userName: '',
  currentPassword: '',
};

export default (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case PASSWORD_GET_REQUEST:
      return { ...state, loading: true };
    case PASSWORD_GET_SUCCESS: {
      const { userName, password } = action.payload;

      return {
        ...state,
        loading: false,
        userName,
        currentPassword: password,
      };
    }
    case PASSWORD_GET_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};
